/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as AccountClosedRouteImport } from './routes/account-closed'
import { Route as BetaTosRouteImport } from './routes/beta-tos'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as HiRouteImport } from './routes/hi'
import { Route as JoinBetaRouteImport } from './routes/join-beta'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppFeedbackRouteImport } from './routes/_app/feedback'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppMyFeedbackRouteImport } from './routes/_app/my-feedback'
import { Route as AppOrderListRouteImport } from './routes/_app/order-list'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppStocktakeRouteImport } from './routes/_app/stocktake'
import { Route as AppTrashRouteImport } from './routes/_app/trash'
import { Route as AppUnitsRouteImport } from './routes/_app/units'
import { Route as AppWhatsNewRouteImport } from './routes/_app/whats-new'
import { Route as SiteIndexRouteImport } from './routes/_site/index'
import { Route as SiteAboutRouteImport } from './routes/_site/about'
import { Route as SiteChangelogRouteImport } from './routes/_site/changelog'
import { Route as SiteDemoRouteImport } from './routes/_site/demo'
import { Route as SiteFeaturesRouteImport } from './routes/_site/features'
import { Route as SiteHelpCentreRouteImport } from './routes/_site/help-centre'
import { Route as SiteLegalRouteImport } from './routes/_site/legal'
import { Route as SitePricingRouteImport } from './routes/_site/pricing'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminBetaRequestsRouteImport } from './routes/_app/admin/beta-requests'
import { Route as AppAdminFeaturesRouteImport } from './routes/_app/admin/features'
import { Route as AppAdminSystemRouteImport } from './routes/_app/admin/system'
import { Route as AppAllergensIndexRouteImport } from './routes/_app/allergens/index'
import { Route as AppAllergensCustomRouteImport } from './routes/_app/allergens/custom'
import { Route as AppAllergensMatrixRouteImport } from './routes/_app/allergens/matrix'
import { Route as AppAllergensMenuRouteImport } from './routes/_app/allergens/menu'
import { Route as AppIngredientsIndexRouteImport } from './routes/_app/ingredients/index'
import { Route as AppIngredientsNewRouteImport } from './routes/_app/ingredients/new'
import { Route as AppMenusIndexRouteImport } from './routes/_app/menus/index'
import { Route as AppMenusNewRouteImport } from './routes/_app/menus/new'
import { Route as AppPrepListsIndexRouteImport } from './routes/_app/prep-lists/index'
import { Route as AppPrepListsIdRouteImport } from './routes/_app/prep-lists/$id'
import { Route as AppPrepListsNewRouteImport } from './routes/_app/prep-lists/new'
import { Route as AppReceivingIndexRouteImport } from './routes/_app/receiving/index'
import { Route as AppReceivingDeliveryIdRouteImport } from './routes/_app/receiving/$deliveryId'
import { Route as AppReceivingNewRouteImport } from './routes/_app/receiving/new'
import { Route as AppRecipesIndexRouteImport } from './routes/_app/recipes/index'
import { Route as AppRecipesNewRouteImport } from './routes/_app/recipes/new'
import { Route as AppAdminActivityIndexRouteImport } from './routes/_app/admin/activity/index'
import { Route as AppAdminActivityEventUuidRouteImport } from './routes/_app/admin/activity/$eventUuid'
import { Route as AppAdminFeedbackIndexRouteImport } from './routes/_app/admin/feedback/index'
import { Route as AppAdminFeedbackFeedbackIdRouteImport } from './routes/_app/admin/feedback/$feedbackId'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users/$userId'
import { Route as AppAdminUsersNewRouteImport } from './routes/_app/admin/users/new'
import { Route as AppAllergensSavedIdRouteImport } from './routes/_app/allergens/saved/$id'
import { Route as AppIngredientsIdEditRouteImport } from './routes/_app/ingredients/$id/edit'
import { Route as AppMenusMenuIdIndexRouteImport } from './routes/_app/menus/$menuId/index'
import { Route as AppMenusMenuIdPrintRouteImport } from './routes/_app/menus/$menuId/print'
import { Route as AppPrepListsIdPrintRouteImport } from './routes/_app/prep-lists/$id_.print'
import { Route as AppRecipesIdIndexRouteImport } from './routes/_app/recipes/$id/index'
import { Route as AppRecipesIdPrintRouteImport } from './routes/_app/recipes/$id/print'
import { Route as AppRecipesIdViewRouteImport } from './routes/_app/recipes/$id/view'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteRoute = SiteRouteImport.update({
  id: '/_site',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountClosedRoute = AccountClosedRouteImport.update({
  id: '/account-closed',
  path: '/account-closed',
  getParentRoute: () => rootRouteImport,
} as any)
const BetaTosRoute = BetaTosRouteImport.update({
  id: '/beta-tos',
  path: '/beta-tos',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const HiRoute = HiRouteImport.update({
  id: '/hi',
  path: '/hi',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinBetaRoute = JoinBetaRouteImport.update({
  id: '/join-beta',
  path: '/join-beta',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedbackRoute = AppFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppMyFeedbackRoute = AppMyFeedbackRouteImport.update({
  id: '/my-feedback',
  path: '/my-feedback',
  getParentRoute: () => AppRoute,
} as any)
const AppOrderListRoute = AppOrderListRouteImport.update({
  id: '/order-list',
  path: '/order-list',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppStocktakeRoute = AppStocktakeRouteImport.update({
  id: '/stocktake',
  path: '/stocktake',
  getParentRoute: () => AppRoute,
} as any)
const AppTrashRoute = AppTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppRoute,
} as any)
const AppUnitsRoute = AppUnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => AppRoute,
} as any)
const AppWhatsNewRoute = AppWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => AppRoute,
} as any)
const SiteIndexRoute = SiteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteRoute,
} as any)
const SiteAboutRoute = SiteAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => SiteRoute,
} as any)
const SiteChangelogRoute = SiteChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => SiteRoute,
} as any)
const SiteDemoRoute = SiteDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => SiteRoute,
} as any)
const SiteFeaturesRoute = SiteFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => SiteRoute,
} as any)
const SiteHelpCentreRoute = SiteHelpCentreRouteImport.update({
  id: '/help-centre',
  path: '/help-centre',
  getParentRoute: () => SiteRoute,
} as any)
const SiteLegalRoute = SiteLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => SiteRoute,
} as any)
const SitePricingRoute = SitePricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => SiteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminBetaRequestsRoute = AppAdminBetaRequestsRouteImport.update({
  id: '/beta-requests',
  path: '/beta-requests',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeaturesRoute = AppAdminFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSystemRoute = AppAdminSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAllergensIndexRoute = AppAllergensIndexRouteImport.update({
  id: '/allergens/',
  path: '/allergens/',
  getParentRoute: () => AppRoute,
} as any)
const AppAllergensCustomRoute = AppAllergensCustomRouteImport.update({
  id: '/allergens/custom',
  path: '/allergens/custom',
  getParentRoute: () => AppRoute,
} as any)
const AppAllergensMatrixRoute = AppAllergensMatrixRouteImport.update({
  id: '/allergens/matrix',
  path: '/allergens/matrix',
  getParentRoute: () => AppRoute,
} as any)
const AppAllergensMenuRoute = AppAllergensMenuRouteImport.update({
  id: '/allergens/menu',
  path: '/allergens/menu',
  getParentRoute: () => AppRoute,
} as any)
const AppIngredientsIndexRoute = AppIngredientsIndexRouteImport.update({
  id: '/ingredients/',
  path: '/ingredients/',
  getParentRoute: () => AppRoute,
} as any)
const AppIngredientsNewRoute = AppIngredientsNewRouteImport.update({
  id: '/ingredients/new',
  path: '/ingredients/new',
  getParentRoute: () => AppRoute,
} as any)
const AppMenusIndexRoute = AppMenusIndexRouteImport.update({
  id: '/menus/',
  path: '/menus/',
  getParentRoute: () => AppRoute,
} as any)
const AppMenusNewRoute = AppMenusNewRouteImport.update({
  id: '/menus/new',
  path: '/menus/new',
  getParentRoute: () => AppRoute,
} as any)
const AppPrepListsIndexRoute = AppPrepListsIndexRouteImport.update({
  id: '/prep-lists/',
  path: '/prep-lists/',
  getParentRoute: () => AppRoute,
} as any)
const AppPrepListsIdRoute = AppPrepListsIdRouteImport.update({
  id: '/prep-lists/$id',
  path: '/prep-lists/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPrepListsNewRoute = AppPrepListsNewRouteImport.update({
  id: '/prep-lists/new',
  path: '/prep-lists/new',
  getParentRoute: () => AppRoute,
} as any)
const AppReceivingIndexRoute = AppReceivingIndexRouteImport.update({
  id: '/receiving/',
  path: '/receiving/',
  getParentRoute: () => AppRoute,
} as any)
const AppReceivingDeliveryIdRoute = AppReceivingDeliveryIdRouteImport.update({
  id: '/receiving/$deliveryId',
  path: '/receiving/$deliveryId',
  getParentRoute: () => AppRoute,
} as any)
const AppReceivingNewRoute = AppReceivingNewRouteImport.update({
  id: '/receiving/new',
  path: '/receiving/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesIndexRoute = AppRecipesIndexRouteImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesNewRoute = AppRecipesNewRouteImport.update({
  id: '/recipes/new',
  path: '/recipes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminActivityIndexRoute = AppAdminActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminActivityEventUuidRoute =
  AppAdminActivityEventUuidRouteImport.update({
    id: '/activity/$eventUuid',
    path: '/activity/$eventUuid',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminFeedbackIndexRoute = AppAdminFeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeedbackFeedbackIdRoute =
  AppAdminFeedbackFeedbackIdRouteImport.update({
    id: '/feedback/$feedbackId',
    path: '/feedback/$feedbackId',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersNewRoute = AppAdminUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAllergensSavedIdRoute = AppAllergensSavedIdRouteImport.update({
  id: '/allergens/saved/$id',
  path: '/allergens/saved/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppIngredientsIdEditRoute = AppIngredientsIdEditRouteImport.update({
  id: '/ingredients/$id/edit',
  path: '/ingredients/$id/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppMenusMenuIdIndexRoute = AppMenusMenuIdIndexRouteImport.update({
  id: '/menus/$menuId/',
  path: '/menus/$menuId/',
  getParentRoute: () => AppRoute,
} as any)
const AppMenusMenuIdPrintRoute = AppMenusMenuIdPrintRouteImport.update({
  id: '/menus/$menuId/print',
  path: '/menus/$menuId/print',
  getParentRoute: () => AppRoute,
} as any)
const AppPrepListsIdPrintRoute = AppPrepListsIdPrintRouteImport.update({
  id: '/prep-lists/$id_/print',
  path: '/prep-lists/$id/print',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesIdIndexRoute = AppRecipesIdIndexRouteImport.update({
  id: '/recipes/$id/',
  path: '/recipes/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesIdPrintRoute = AppRecipesIdPrintRouteImport.update({
  id: '/recipes/$id/print',
  path: '/recipes/$id/print',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesIdViewRoute = AppRecipesIdViewRouteImport.update({
  id: '/recipes/$id/view',
  path: '/recipes/$id/view',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof SiteIndexRoute
  '/account-closed': typeof AccountClosedRoute
  '/beta-tos': typeof BetaTosRoute
  '/change-password': typeof ChangePasswordRoute
  '/hi': typeof HiRoute
  '/join-beta': typeof JoinBetaRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/feedback': typeof AppFeedbackRoute
  '/help': typeof AppHelpRoute
  '/my-feedback': typeof AppMyFeedbackRoute
  '/order-list': typeof AppOrderListRoute
  '/settings': typeof AppSettingsRoute
  '/stocktake': typeof AppStocktakeRoute
  '/trash': typeof AppTrashRoute
  '/units': typeof AppUnitsRoute
  '/whats-new': typeof AppWhatsNewRoute
  '/about': typeof SiteAboutRoute
  '/changelog': typeof SiteChangelogRoute
  '/demo': typeof SiteDemoRoute
  '/features': typeof SiteFeaturesRoute
  '/help-centre': typeof SiteHelpCentreRoute
  '/legal': typeof SiteLegalRoute
  '/pricing': typeof SitePricingRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/beta-requests': typeof AppAdminBetaRequestsRoute
  '/admin/features': typeof AppAdminFeaturesRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/allergens/custom': typeof AppAllergensCustomRoute
  '/allergens/matrix': typeof AppAllergensMatrixRoute
  '/allergens/menu': typeof AppAllergensMenuRoute
  '/ingredients/new': typeof AppIngredientsNewRoute
  '/menus/new': typeof AppMenusNewRoute
  '/prep-lists/$id': typeof AppPrepListsIdRoute
  '/prep-lists/new': typeof AppPrepListsNewRoute
  '/receiving/$deliveryId': typeof AppReceivingDeliveryIdRoute
  '/receiving/new': typeof AppReceivingNewRoute
  '/recipes/new': typeof AppRecipesNewRoute
  '/admin/': typeof AppAdminIndexRoute
  '/allergens/': typeof AppAllergensIndexRoute
  '/ingredients/': typeof AppIngredientsIndexRoute
  '/menus/': typeof AppMenusIndexRoute
  '/prep-lists/': typeof AppPrepListsIndexRoute
  '/receiving/': typeof AppReceivingIndexRoute
  '/recipes/': typeof AppRecipesIndexRoute
  '/admin/activity/$eventUuid': typeof AppAdminActivityEventUuidRoute
  '/admin/feedback/$feedbackId': typeof AppAdminFeedbackFeedbackIdRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/admin/users/new': typeof AppAdminUsersNewRoute
  '/allergens/saved/$id': typeof AppAllergensSavedIdRoute
  '/ingredients/$id/edit': typeof AppIngredientsIdEditRoute
  '/menus/$menuId/print': typeof AppMenusMenuIdPrintRoute
  '/prep-lists/$id/print': typeof AppPrepListsIdPrintRoute
  '/recipes/$id/print': typeof AppRecipesIdPrintRoute
  '/recipes/$id/view': typeof AppRecipesIdViewRoute
  '/admin/activity/': typeof AppAdminActivityIndexRoute
  '/admin/feedback/': typeof AppAdminFeedbackIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/menus/$menuId/': typeof AppMenusMenuIdIndexRoute
  '/recipes/$id/': typeof AppRecipesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof SiteIndexRoute
  '/account-closed': typeof AccountClosedRoute
  '/beta-tos': typeof BetaTosRoute
  '/change-password': typeof ChangePasswordRoute
  '/hi': typeof HiRoute
  '/join-beta': typeof JoinBetaRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRoute
  '/dashboard': typeof AppDashboardRoute
  '/feedback': typeof AppFeedbackRoute
  '/help': typeof AppHelpRoute
  '/my-feedback': typeof AppMyFeedbackRoute
  '/order-list': typeof AppOrderListRoute
  '/settings': typeof AppSettingsRoute
  '/stocktake': typeof AppStocktakeRoute
  '/trash': typeof AppTrashRoute
  '/units': typeof AppUnitsRoute
  '/whats-new': typeof AppWhatsNewRoute
  '/about': typeof SiteAboutRoute
  '/changelog': typeof SiteChangelogRoute
  '/demo': typeof SiteDemoRoute
  '/features': typeof SiteFeaturesRoute
  '/help-centre': typeof SiteHelpCentreRoute
  '/legal': typeof SiteLegalRoute
  '/pricing': typeof SitePricingRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/beta-requests': typeof AppAdminBetaRequestsRoute
  '/admin/features': typeof AppAdminFeaturesRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/allergens/custom': typeof AppAllergensCustomRoute
  '/allergens/matrix': typeof AppAllergensMatrixRoute
  '/allergens/menu': typeof AppAllergensMenuRoute
  '/ingredients/new': typeof AppIngredientsNewRoute
  '/menus/new': typeof AppMenusNewRoute
  '/prep-lists/$id': typeof AppPrepListsIdRoute
  '/prep-lists/new': typeof AppPrepListsNewRoute
  '/receiving/$deliveryId': typeof AppReceivingDeliveryIdRoute
  '/receiving/new': typeof AppReceivingNewRoute
  '/recipes/new': typeof AppRecipesNewRoute
  '/admin': typeof AppAdminIndexRoute
  '/allergens': typeof AppAllergensIndexRoute
  '/ingredients': typeof AppIngredientsIndexRoute
  '/menus': typeof AppMenusIndexRoute
  '/prep-lists': typeof AppPrepListsIndexRoute
  '/receiving': typeof AppReceivingIndexRoute
  '/recipes': typeof AppRecipesIndexRoute
  '/admin/activity/$eventUuid': typeof AppAdminActivityEventUuidRoute
  '/admin/feedback/$feedbackId': typeof AppAdminFeedbackFeedbackIdRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/admin/users/new': typeof AppAdminUsersNewRoute
  '/allergens/saved/$id': typeof AppAllergensSavedIdRoute
  '/ingredients/$id/edit': typeof AppIngredientsIdEditRoute
  '/menus/$menuId/print': typeof AppMenusMenuIdPrintRoute
  '/prep-lists/$id/print': typeof AppPrepListsIdPrintRoute
  '/recipes/$id/print': typeof AppRecipesIdPrintRoute
  '/recipes/$id/view': typeof AppRecipesIdViewRoute
  '/admin/activity': typeof AppAdminActivityIndexRoute
  '/admin/feedback': typeof AppAdminFeedbackIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/menus/$menuId': typeof AppMenusMenuIdIndexRoute
  '/recipes/$id': typeof AppRecipesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_site': typeof SiteRouteWithChildren
  '/account-closed': typeof AccountClosedRoute
  '/beta-tos': typeof BetaTosRoute
  '/change-password': typeof ChangePasswordRoute
  '/hi': typeof HiRoute
  '/join-beta': typeof JoinBetaRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/welcome': typeof WelcomeRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/feedback': typeof AppFeedbackRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/my-feedback': typeof AppMyFeedbackRoute
  '/_app/order-list': typeof AppOrderListRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/stocktake': typeof AppStocktakeRoute
  '/_app/trash': typeof AppTrashRoute
  '/_app/units': typeof AppUnitsRoute
  '/_app/whats-new': typeof AppWhatsNewRoute
  '/_site/about': typeof SiteAboutRoute
  '/_site/changelog': typeof SiteChangelogRoute
  '/_site/demo': typeof SiteDemoRoute
  '/_site/features': typeof SiteFeaturesRoute
  '/_site/help-centre': typeof SiteHelpCentreRoute
  '/_site/legal': typeof SiteLegalRoute
  '/_site/pricing': typeof SitePricingRoute
  '/_site/': typeof SiteIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/beta-requests': typeof AppAdminBetaRequestsRoute
  '/_app/admin/features': typeof AppAdminFeaturesRoute
  '/_app/admin/system': typeof AppAdminSystemRoute
  '/_app/allergens/custom': typeof AppAllergensCustomRoute
  '/_app/allergens/matrix': typeof AppAllergensMatrixRoute
  '/_app/allergens/menu': typeof AppAllergensMenuRoute
  '/_app/ingredients/new': typeof AppIngredientsNewRoute
  '/_app/menus/new': typeof AppMenusNewRoute
  '/_app/prep-lists/$id': typeof AppPrepListsIdRoute
  '/_app/prep-lists/new': typeof AppPrepListsNewRoute
  '/_app/receiving/$deliveryId': typeof AppReceivingDeliveryIdRoute
  '/_app/receiving/new': typeof AppReceivingNewRoute
  '/_app/recipes/new': typeof AppRecipesNewRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/allergens/': typeof AppAllergensIndexRoute
  '/_app/ingredients/': typeof AppIngredientsIndexRoute
  '/_app/menus/': typeof AppMenusIndexRoute
  '/_app/prep-lists/': typeof AppPrepListsIndexRoute
  '/_app/receiving/': typeof AppReceivingIndexRoute
  '/_app/recipes/': typeof AppRecipesIndexRoute
  '/_app/admin/activity/$eventUuid': typeof AppAdminActivityEventUuidRoute
  '/_app/admin/feedback/$feedbackId': typeof AppAdminFeedbackFeedbackIdRoute
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRoute
  '/_app/admin/users/new': typeof AppAdminUsersNewRoute
  '/_app/allergens/saved/$id': typeof AppAllergensSavedIdRoute
  '/_app/ingredients/$id/edit': typeof AppIngredientsIdEditRoute
  '/_app/menus/$menuId/print': typeof AppMenusMenuIdPrintRoute
  '/_app/prep-lists/$id_/print': typeof AppPrepListsIdPrintRoute
  '/_app/recipes/$id/print': typeof AppRecipesIdPrintRoute
  '/_app/recipes/$id/view': typeof AppRecipesIdViewRoute
  '/_app/admin/activity/': typeof AppAdminActivityIndexRoute
  '/_app/admin/feedback/': typeof AppAdminFeedbackIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/menus/$menuId/': typeof AppMenusMenuIdIndexRoute
  '/_app/recipes/$id/': typeof AppRecipesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-closed'
    | '/beta-tos'
    | '/change-password'
    | '/hi'
    | '/join-beta'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/welcome'
    | '/admin'
    | '/dashboard'
    | '/feedback'
    | '/help'
    | '/my-feedback'
    | '/order-list'
    | '/settings'
    | '/stocktake'
    | '/trash'
    | '/units'
    | '/whats-new'
    | '/about'
    | '/changelog'
    | '/demo'
    | '/features'
    | '/help-centre'
    | '/legal'
    | '/pricing'
    | '/admin/audit'
    | '/admin/beta-requests'
    | '/admin/features'
    | '/admin/system'
    | '/allergens/custom'
    | '/allergens/matrix'
    | '/allergens/menu'
    | '/ingredients/new'
    | '/menus/new'
    | '/prep-lists/$id'
    | '/prep-lists/new'
    | '/receiving/$deliveryId'
    | '/receiving/new'
    | '/recipes/new'
    | '/admin/'
    | '/allergens/'
    | '/ingredients/'
    | '/menus/'
    | '/prep-lists/'
    | '/receiving/'
    | '/recipes/'
    | '/admin/activity/$eventUuid'
    | '/admin/feedback/$feedbackId'
    | '/admin/users/$userId'
    | '/admin/users/new'
    | '/allergens/saved/$id'
    | '/ingredients/$id/edit'
    | '/menus/$menuId/print'
    | '/prep-lists/$id/print'
    | '/recipes/$id/print'
    | '/recipes/$id/view'
    | '/admin/activity/'
    | '/admin/feedback/'
    | '/admin/users/'
    | '/menus/$menuId/'
    | '/recipes/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-closed'
    | '/beta-tos'
    | '/change-password'
    | '/hi'
    | '/join-beta'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/welcome'
    | '/dashboard'
    | '/feedback'
    | '/help'
    | '/my-feedback'
    | '/order-list'
    | '/settings'
    | '/stocktake'
    | '/trash'
    | '/units'
    | '/whats-new'
    | '/about'
    | '/changelog'
    | '/demo'
    | '/features'
    | '/help-centre'
    | '/legal'
    | '/pricing'
    | '/admin/audit'
    | '/admin/beta-requests'
    | '/admin/features'
    | '/admin/system'
    | '/allergens/custom'
    | '/allergens/matrix'
    | '/allergens/menu'
    | '/ingredients/new'
    | '/menus/new'
    | '/prep-lists/$id'
    | '/prep-lists/new'
    | '/receiving/$deliveryId'
    | '/receiving/new'
    | '/recipes/new'
    | '/admin'
    | '/allergens'
    | '/ingredients'
    | '/menus'
    | '/prep-lists'
    | '/receiving'
    | '/recipes'
    | '/admin/activity/$eventUuid'
    | '/admin/feedback/$feedbackId'
    | '/admin/users/$userId'
    | '/admin/users/new'
    | '/allergens/saved/$id'
    | '/ingredients/$id/edit'
    | '/menus/$menuId/print'
    | '/prep-lists/$id/print'
    | '/recipes/$id/print'
    | '/recipes/$id/view'
    | '/admin/activity'
    | '/admin/feedback'
    | '/admin/users'
    | '/menus/$menuId'
    | '/recipes/$id'
  id:
    | '__root__'
    | '/_app'
    | '/_site'
    | '/account-closed'
    | '/beta-tos'
    | '/change-password'
    | '/hi'
    | '/join-beta'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/welcome'
    | '/_app/admin'
    | '/_app/dashboard'
    | '/_app/feedback'
    | '/_app/help'
    | '/_app/my-feedback'
    | '/_app/order-list'
    | '/_app/settings'
    | '/_app/stocktake'
    | '/_app/trash'
    | '/_app/units'
    | '/_app/whats-new'
    | '/_site/about'
    | '/_site/changelog'
    | '/_site/demo'
    | '/_site/features'
    | '/_site/help-centre'
    | '/_site/legal'
    | '/_site/pricing'
    | '/_site/'
    | '/_app/admin/audit'
    | '/_app/admin/beta-requests'
    | '/_app/admin/features'
    | '/_app/admin/system'
    | '/_app/allergens/custom'
    | '/_app/allergens/matrix'
    | '/_app/allergens/menu'
    | '/_app/ingredients/new'
    | '/_app/menus/new'
    | '/_app/prep-lists/$id'
    | '/_app/prep-lists/new'
    | '/_app/receiving/$deliveryId'
    | '/_app/receiving/new'
    | '/_app/recipes/new'
    | '/_app/admin/'
    | '/_app/allergens/'
    | '/_app/ingredients/'
    | '/_app/menus/'
    | '/_app/prep-lists/'
    | '/_app/receiving/'
    | '/_app/recipes/'
    | '/_app/admin/activity/$eventUuid'
    | '/_app/admin/feedback/$feedbackId'
    | '/_app/admin/users/$userId'
    | '/_app/admin/users/new'
    | '/_app/allergens/saved/$id'
    | '/_app/ingredients/$id/edit'
    | '/_app/menus/$menuId/print'
    | '/_app/prep-lists/$id_/print'
    | '/_app/recipes/$id/print'
    | '/_app/recipes/$id/view'
    | '/_app/admin/activity/'
    | '/_app/admin/feedback/'
    | '/_app/admin/users/'
    | '/_app/menus/$menuId/'
    | '/_app/recipes/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SiteRoute: typeof SiteRouteWithChildren
  AccountClosedRoute: typeof AccountClosedRoute
  BetaTosRoute: typeof BetaTosRoute
  ChangePasswordRoute: typeof ChangePasswordRoute
  HiRoute: typeof HiRoute
  JoinBetaRoute: typeof JoinBetaRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_site': {
      id: '/_site'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-closed': {
      id: '/account-closed'
      path: '/account-closed'
      fullPath: '/account-closed'
      preLoaderRoute: typeof AccountClosedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beta-tos': {
      id: '/beta-tos'
      path: '/beta-tos'
      fullPath: '/beta-tos'
      preLoaderRoute: typeof BetaTosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hi': {
      id: '/hi'
      path: '/hi'
      fullPath: '/hi'
      preLoaderRoute: typeof HiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join-beta': {
      id: '/join-beta'
      path: '/join-beta'
      fullPath: '/join-beta'
      preLoaderRoute: typeof JoinBetaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feedback': {
      id: '/_app/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AppFeedbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-feedback': {
      id: '/_app/my-feedback'
      path: '/my-feedback'
      fullPath: '/my-feedback'
      preLoaderRoute: typeof AppMyFeedbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/order-list': {
      id: '/_app/order-list'
      path: '/order-list'
      fullPath: '/order-list'
      preLoaderRoute: typeof AppOrderListRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stocktake': {
      id: '/_app/stocktake'
      path: '/stocktake'
      fullPath: '/stocktake'
      preLoaderRoute: typeof AppStocktakeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trash': {
      id: '/_app/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof AppTrashRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/units': {
      id: '/_app/units'
      path: '/units'
      fullPath: '/units'
      preLoaderRoute: typeof AppUnitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/whats-new': {
      id: '/_app/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof AppWhatsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_site/': {
      id: '/_site/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SiteIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/about': {
      id: '/_site/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof SiteAboutRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/changelog': {
      id: '/_site/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof SiteChangelogRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/demo': {
      id: '/_site/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof SiteDemoRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/features': {
      id: '/_site/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof SiteFeaturesRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/help-centre': {
      id: '/_site/help-centre'
      path: '/help-centre'
      fullPath: '/help-centre'
      preLoaderRoute: typeof SiteHelpCentreRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/legal': {
      id: '/_site/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof SiteLegalRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/pricing': {
      id: '/_site/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof SitePricingRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/beta-requests': {
      id: '/_app/admin/beta-requests'
      path: '/beta-requests'
      fullPath: '/admin/beta-requests'
      preLoaderRoute: typeof AppAdminBetaRequestsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/features': {
      id: '/_app/admin/features'
      path: '/features'
      fullPath: '/admin/features'
      preLoaderRoute: typeof AppAdminFeaturesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/system': {
      id: '/_app/admin/system'
      path: '/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AppAdminSystemRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/allergens/': {
      id: '/_app/allergens/'
      path: '/allergens'
      fullPath: '/allergens/'
      preLoaderRoute: typeof AppAllergensIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/allergens/custom': {
      id: '/_app/allergens/custom'
      path: '/allergens/custom'
      fullPath: '/allergens/custom'
      preLoaderRoute: typeof AppAllergensCustomRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/allergens/matrix': {
      id: '/_app/allergens/matrix'
      path: '/allergens/matrix'
      fullPath: '/allergens/matrix'
      preLoaderRoute: typeof AppAllergensMatrixRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/allergens/menu': {
      id: '/_app/allergens/menu'
      path: '/allergens/menu'
      fullPath: '/allergens/menu'
      preLoaderRoute: typeof AppAllergensMenuRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ingredients/': {
      id: '/_app/ingredients/'
      path: '/ingredients'
      fullPath: '/ingredients/'
      preLoaderRoute: typeof AppIngredientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ingredients/new': {
      id: '/_app/ingredients/new'
      path: '/ingredients/new'
      fullPath: '/ingredients/new'
      preLoaderRoute: typeof AppIngredientsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/menus/': {
      id: '/_app/menus/'
      path: '/menus'
      fullPath: '/menus/'
      preLoaderRoute: typeof AppMenusIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/menus/new': {
      id: '/_app/menus/new'
      path: '/menus/new'
      fullPath: '/menus/new'
      preLoaderRoute: typeof AppMenusNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prep-lists/': {
      id: '/_app/prep-lists/'
      path: '/prep-lists'
      fullPath: '/prep-lists/'
      preLoaderRoute: typeof AppPrepListsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prep-lists/$id': {
      id: '/_app/prep-lists/$id'
      path: '/prep-lists/$id'
      fullPath: '/prep-lists/$id'
      preLoaderRoute: typeof AppPrepListsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prep-lists/new': {
      id: '/_app/prep-lists/new'
      path: '/prep-lists/new'
      fullPath: '/prep-lists/new'
      preLoaderRoute: typeof AppPrepListsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receiving/': {
      id: '/_app/receiving/'
      path: '/receiving'
      fullPath: '/receiving/'
      preLoaderRoute: typeof AppReceivingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receiving/$deliveryId': {
      id: '/_app/receiving/$deliveryId'
      path: '/receiving/$deliveryId'
      fullPath: '/receiving/$deliveryId'
      preLoaderRoute: typeof AppReceivingDeliveryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/receiving/new': {
      id: '/_app/receiving/new'
      path: '/receiving/new'
      fullPath: '/receiving/new'
      preLoaderRoute: typeof AppReceivingNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/': {
      id: '/_app/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof AppRecipesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/new': {
      id: '/_app/recipes/new'
      path: '/recipes/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof AppRecipesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/activity/': {
      id: '/_app/admin/activity/'
      path: '/activity'
      fullPath: '/admin/activity/'
      preLoaderRoute: typeof AppAdminActivityIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/activity/$eventUuid': {
      id: '/_app/admin/activity/$eventUuid'
      path: '/activity/$eventUuid'
      fullPath: '/admin/activity/$eventUuid'
      preLoaderRoute: typeof AppAdminActivityEventUuidRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/feedback/': {
      id: '/_app/admin/feedback/'
      path: '/feedback'
      fullPath: '/admin/feedback/'
      preLoaderRoute: typeof AppAdminFeedbackIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/feedback/$feedbackId': {
      id: '/_app/admin/feedback/$feedbackId'
      path: '/feedback/$feedbackId'
      fullPath: '/admin/feedback/$feedbackId'
      preLoaderRoute: typeof AppAdminFeedbackFeedbackIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users/new': {
      id: '/_app/admin/users/new'
      path: '/users/new'
      fullPath: '/admin/users/new'
      preLoaderRoute: typeof AppAdminUsersNewRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/allergens/saved/$id': {
      id: '/_app/allergens/saved/$id'
      path: '/allergens/saved/$id'
      fullPath: '/allergens/saved/$id'
      preLoaderRoute: typeof AppAllergensSavedIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ingredients/$id/edit': {
      id: '/_app/ingredients/$id/edit'
      path: '/ingredients/$id/edit'
      fullPath: '/ingredients/$id/edit'
      preLoaderRoute: typeof AppIngredientsIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/menus/$menuId/': {
      id: '/_app/menus/$menuId/'
      path: '/menus/$menuId'
      fullPath: '/menus/$menuId/'
      preLoaderRoute: typeof AppMenusMenuIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/menus/$menuId/print': {
      id: '/_app/menus/$menuId/print'
      path: '/menus/$menuId/print'
      fullPath: '/menus/$menuId/print'
      preLoaderRoute: typeof AppMenusMenuIdPrintRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/prep-lists/$id_/print': {
      id: '/_app/prep-lists/$id_/print'
      path: '/prep-lists/$id/print'
      fullPath: '/prep-lists/$id/print'
      preLoaderRoute: typeof AppPrepListsIdPrintRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/$id/': {
      id: '/_app/recipes/$id/'
      path: '/recipes/$id'
      fullPath: '/recipes/$id/'
      preLoaderRoute: typeof AppRecipesIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/$id/print': {
      id: '/_app/recipes/$id/print'
      path: '/recipes/$id/print'
      fullPath: '/recipes/$id/print'
      preLoaderRoute: typeof AppRecipesIdPrintRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/$id/view': {
      id: '/_app/recipes/$id/view'
      path: '/recipes/$id/view'
      fullPath: '/recipes/$id/view'
      preLoaderRoute: typeof AppRecipesIdViewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminBetaRequestsRoute: typeof AppAdminBetaRequestsRoute
  AppAdminFeaturesRoute: typeof AppAdminFeaturesRoute
  AppAdminSystemRoute: typeof AppAdminSystemRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminActivityEventUuidRoute: typeof AppAdminActivityEventUuidRoute
  AppAdminFeedbackFeedbackIdRoute: typeof AppAdminFeedbackFeedbackIdRoute
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute
  AppAdminUsersNewRoute: typeof AppAdminUsersNewRoute
  AppAdminActivityIndexRoute: typeof AppAdminActivityIndexRoute
  AppAdminFeedbackIndexRoute: typeof AppAdminFeedbackIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminBetaRequestsRoute: AppAdminBetaRequestsRoute,
  AppAdminFeaturesRoute: AppAdminFeaturesRoute,
  AppAdminSystemRoute: AppAdminSystemRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminActivityEventUuidRoute: AppAdminActivityEventUuidRoute,
  AppAdminFeedbackFeedbackIdRoute: AppAdminFeedbackFeedbackIdRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppAdminUsersNewRoute: AppAdminUsersNewRoute,
  AppAdminActivityIndexRoute: AppAdminActivityIndexRoute,
  AppAdminFeedbackIndexRoute: AppAdminFeedbackIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppFeedbackRoute: typeof AppFeedbackRoute
  AppHelpRoute: typeof AppHelpRoute
  AppMyFeedbackRoute: typeof AppMyFeedbackRoute
  AppOrderListRoute: typeof AppOrderListRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStocktakeRoute: typeof AppStocktakeRoute
  AppTrashRoute: typeof AppTrashRoute
  AppUnitsRoute: typeof AppUnitsRoute
  AppWhatsNewRoute: typeof AppWhatsNewRoute
  AppAllergensCustomRoute: typeof AppAllergensCustomRoute
  AppAllergensMatrixRoute: typeof AppAllergensMatrixRoute
  AppAllergensMenuRoute: typeof AppAllergensMenuRoute
  AppIngredientsNewRoute: typeof AppIngredientsNewRoute
  AppMenusNewRoute: typeof AppMenusNewRoute
  AppPrepListsIdRoute: typeof AppPrepListsIdRoute
  AppPrepListsNewRoute: typeof AppPrepListsNewRoute
  AppReceivingDeliveryIdRoute: typeof AppReceivingDeliveryIdRoute
  AppReceivingNewRoute: typeof AppReceivingNewRoute
  AppRecipesNewRoute: typeof AppRecipesNewRoute
  AppAllergensIndexRoute: typeof AppAllergensIndexRoute
  AppIngredientsIndexRoute: typeof AppIngredientsIndexRoute
  AppMenusIndexRoute: typeof AppMenusIndexRoute
  AppPrepListsIndexRoute: typeof AppPrepListsIndexRoute
  AppReceivingIndexRoute: typeof AppReceivingIndexRoute
  AppRecipesIndexRoute: typeof AppRecipesIndexRoute
  AppAllergensSavedIdRoute: typeof AppAllergensSavedIdRoute
  AppIngredientsIdEditRoute: typeof AppIngredientsIdEditRoute
  AppMenusMenuIdPrintRoute: typeof AppMenusMenuIdPrintRoute
  AppPrepListsIdPrintRoute: typeof AppPrepListsIdPrintRoute
  AppRecipesIdPrintRoute: typeof AppRecipesIdPrintRoute
  AppRecipesIdViewRoute: typeof AppRecipesIdViewRoute
  AppMenusMenuIdIndexRoute: typeof AppMenusMenuIdIndexRoute
  AppRecipesIdIndexRoute: typeof AppRecipesIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppFeedbackRoute: AppFeedbackRoute,
  AppHelpRoute: AppHelpRoute,
  AppMyFeedbackRoute: AppMyFeedbackRoute,
  AppOrderListRoute: AppOrderListRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStocktakeRoute: AppStocktakeRoute,
  AppTrashRoute: AppTrashRoute,
  AppUnitsRoute: AppUnitsRoute,
  AppWhatsNewRoute: AppWhatsNewRoute,
  AppAllergensCustomRoute: AppAllergensCustomRoute,
  AppAllergensMatrixRoute: AppAllergensMatrixRoute,
  AppAllergensMenuRoute: AppAllergensMenuRoute,
  AppIngredientsNewRoute: AppIngredientsNewRoute,
  AppMenusNewRoute: AppMenusNewRoute,
  AppPrepListsIdRoute: AppPrepListsIdRoute,
  AppPrepListsNewRoute: AppPrepListsNewRoute,
  AppReceivingDeliveryIdRoute: AppReceivingDeliveryIdRoute,
  AppReceivingNewRoute: AppReceivingNewRoute,
  AppRecipesNewRoute: AppRecipesNewRoute,
  AppAllergensIndexRoute: AppAllergensIndexRoute,
  AppIngredientsIndexRoute: AppIngredientsIndexRoute,
  AppMenusIndexRoute: AppMenusIndexRoute,
  AppPrepListsIndexRoute: AppPrepListsIndexRoute,
  AppReceivingIndexRoute: AppReceivingIndexRoute,
  AppRecipesIndexRoute: AppRecipesIndexRoute,
  AppAllergensSavedIdRoute: AppAllergensSavedIdRoute,
  AppIngredientsIdEditRoute: AppIngredientsIdEditRoute,
  AppMenusMenuIdPrintRoute: AppMenusMenuIdPrintRoute,
  AppPrepListsIdPrintRoute: AppPrepListsIdPrintRoute,
  AppRecipesIdPrintRoute: AppRecipesIdPrintRoute,
  AppRecipesIdViewRoute: AppRecipesIdViewRoute,
  AppMenusMenuIdIndexRoute: AppMenusMenuIdIndexRoute,
  AppRecipesIdIndexRoute: AppRecipesIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface SiteRouteChildren {
  SiteAboutRoute: typeof SiteAboutRoute
  SiteChangelogRoute: typeof SiteChangelogRoute
  SiteDemoRoute: typeof SiteDemoRoute
  SiteFeaturesRoute: typeof SiteFeaturesRoute
  SiteHelpCentreRoute: typeof SiteHelpCentreRoute
  SiteLegalRoute: typeof SiteLegalRoute
  SitePricingRoute: typeof SitePricingRoute
  SiteIndexRoute: typeof SiteIndexRoute
}

const SiteRouteChildren: SiteRouteChildren = {
  SiteAboutRoute: SiteAboutRoute,
  SiteChangelogRoute: SiteChangelogRoute,
  SiteDemoRoute: SiteDemoRoute,
  SiteFeaturesRoute: SiteFeaturesRoute,
  SiteHelpCentreRoute: SiteHelpCentreRoute,
  SiteLegalRoute: SiteLegalRoute,
  SitePricingRoute: SitePricingRoute,
  SiteIndexRoute: SiteIndexRoute,
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SiteRoute: SiteRouteWithChildren,
  AccountClosedRoute: AccountClosedRoute,
  BetaTosRoute: BetaTosRoute,
  ChangePasswordRoute: ChangePasswordRoute,
  HiRoute: HiRoute,
  JoinBetaRoute: JoinBetaRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
